import { type FC } from 'react'
import { type DefaultProps } from '../common'

export const IconErrorCircle: FC<DefaultProps> = ({ className, id, testId, ariaLabel }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      fill="none"
      className={className}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    >
      <path
        stroke="#FB5653"
        strokeWidth={1.5}
        d="M20 39.25C9.369 39.25.75 30.631.75 20S9.369.75 20 .75 39.25 9.369 39.25 20 30.631 39.25 20 39.25z"
      />
      <path
        fill="#FB5653"
        d="M20 9a1 1 0 0 0-1 1v14a1 1 0 1 0 2 0V10a1 1 0 0 0-1-1zm0 20a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
      />
    </svg>
  )
}
